var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images[_vm.activeImage])?_c('logo-slides',{attrs:{"image":_vm.images[_vm.activeImage]}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }